module.exports = __webpack_public_path__ + "static/img/zd01.611a1dd2.svg";